export default __webpack_public_path__ + "static/media/IMG_20190601_194707_380.e82db178.jpg";